/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefSubscriptionChangeResponse } from '../../models/api-def-subscription-change-response';

export interface OrganizationsCancelScheduledChange$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
      body: {

/**
 * Stable caller-generated ID reused for every retry of this schedule-release mutation.
 */
'mutationId': string;
}
}

export function organizationsCancelScheduledChange(http: HttpClient, rootUrl: string, params: OrganizationsCancelScheduledChange$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSubscriptionChangeResponse>> {
  const rb = new RequestBuilder(rootUrl, organizationsCancelScheduledChange.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefSubscriptionChangeResponse>;
    })
  );
}

organizationsCancelScheduledChange.PATH = '/organizations/{organizationId}/subscription/scheduled-change';
